import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function WhatsIncluded() {
  const modules = [{
    block: 'Inicio Rápido',
    content: 'Ruta de 7 días + Materiales inteligentes + Seguridad'
  }, {
    block: 'Bases',
    content: 'Ceras + Temperaturas + Mechas + Fragancias + Colorantes'
  }, {
    block: 'Técnicas',
    content: 'Vela en vaso + Moldes + Marmoleado + Degradados + Atemporales'
  }, {
    block: 'Aromaterapia',
    content: 'Familias olfativas + 20 blends + Nombres que venden'
  }, {
    block: 'Negocio',
    content: 'Costeo + Precios + Lanzamiento en Facebook y Shopify'
  }];
  const bonuses = ['Manual de Recetas Base (7 fórmulas maestras)', 'Guía de Solución de Problemas (túnel, hollín, sin aroma)', 'Bitácora de Pruebas y Lotes', 'Calculadora Imprimible de Costos', 'Plantillas de Etiquetas (3 tamaños)', 'Blend Book Completo: 50 Mezclas Aromáticas', 'Catálogo Colección Casa Calma (8 aromas listos para vender)', 'Guía de Fotografía con Celular', 'Guía de Empaque Premium', '50 Descripciones Listas para Facebook y Shopify'];
  const collection = [{
    aroma: 'Calma Lavanda',
    desc: '"Para los momentos en que más lo necesitas."',
    price: '$22-24'
  }, {
    aroma: 'Eucalipto Puro',
    desc: '"Lleva el spa a tu hogar cada noche."',
    price: '$22-24'
  }, {
    aroma: 'Brisa Cítrica',
    desc: '"Cítricos luminosos y casa recién ordenada."',
    price: '$22-24'
  }, {
    aroma: 'Té Blanco & Jazmín',
    desc: '"La elegancia discreta en un frasco."',
    price: '$24-26'
  }, {
    aroma: 'Ámbar Suave',
    desc: '"El abrazo que tu hogar necesita."',
    price: '$24-26'
  }, {
    aroma: 'Sándalo & Vainilla',
    desc: '"Cremosa, fina y absolutamente irresistible."',
    price: '$25-28'
  }, {
    aroma: 'Otoño Dorado',
    desc: '"Especias cálidas sin exceso."',
    price: '$24-26'
  }, {
    aroma: 'Noche Invernal',
    desc: '"Bosque limpio desde tu sala."',
    price: '$24-26'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="bg-brand-alt py-14" data-id="element-144">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="text-center mb-10" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text" data-id="element-147">
            QUÉ INCLUYE
          </h2>
        </div>

        {/* Modules Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-148">
          <h3 className="text-2xl font-bold mb-6 text-center text-brand-text" data-id="element-149">
            📚 20 Módulos PDF Completos
          </h3>
          <div className="overflow-x-auto bg-brand-bg rounded-2xl shadow-sm border border-brand-line/30" data-id="element-150">
            <table className="w-full text-left border-collapse" data-id="element-151">
              <thead data-id="element-152">
                <tr className="border-b border-brand-line/30 bg-brand-accent/20" data-id="element-153">
                  <th className="p-4 font-semibold text-brand-text w-1/3" data-id="element-154">
                    Bloque
                  </th>
                  <th className="p-4 font-semibold text-brand-text" data-id="element-155">Módulos</th>
                </tr>
              </thead>
              <tbody data-id="element-156">
                {modules.map((mod, i) => <tr key={i} className="border-b border-brand-line/10 last:border-0 hover:bg-brand-accent/5 transition-colors" data-id="element-157">
                    <td className="p-4 font-medium text-brand-text align-top" data-id="element-158">
                      {mod.block}
                    </td>
                    <td className="p-4 text-brand-subtext" data-id="element-159">{mod.content}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <SectionDivider data-id="element-160" />

        {/* Bonuses Section */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={containerVariants} className="mb-12 mt-8" data-id="element-161">
          <h3 className="text-2xl font-bold mb-6 text-center text-brand-text" data-id="element-162">
            🎁 10 Bonos Imprimibles
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-163">
            {bonuses.map((bonus, i) => <motion.div key={i} variants={itemVariants} className="flex items-start gap-3 bg-brand-bg p-4 rounded-xl border border-brand-line/20" data-id="element-164">
                <div className="mt-0.5 bg-green-100 text-green-700 rounded-full p-1 flex-shrink-0" data-id="element-165">
                  <Check className="w-4 h-4" strokeWidth={3} data-id="element-166" />
                </div>
                <span className="text-brand-text font-medium" data-id="element-167">{bonus}</span>
              </motion.div>)}
          </div>
        </motion.div>

        <SectionDivider data-id="element-168" />

        {/* Collection Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8" data-id="element-169">
          <h3 className="text-2xl font-bold mb-6 text-center text-brand-text" data-id="element-170">
            🕯️ La Colección Casa Calma Incluida
          </h3>
          <div className="overflow-x-auto bg-brand-bg rounded-2xl shadow-sm border border-brand-line/30" data-id="element-171">
            <table className="w-full text-left border-collapse" data-id="element-172">
              <thead data-id="element-173">
                <tr className="border-b border-brand-line/30 bg-brand-accent/20" data-id="element-174">
                  <th className="p-4 font-semibold text-brand-text" data-id="element-175">Aroma</th>
                  <th className="p-4 font-semibold text-brand-text hidden sm:table-cell" data-id="element-176">
                    Descripción
                  </th>
                  <th className="p-4 font-semibold text-brand-text text-right" data-id="element-177">
                    Precio
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-178">
                {collection.map((item, i) => <tr key={i} className="border-b border-brand-line/10 last:border-0 hover:bg-brand-accent/5 transition-colors" data-id="element-179">
                    <td className="p-4 font-medium text-brand-text whitespace-nowrap" data-id="element-180">
                      {item.aroma}
                    </td>
                    <td className="p-4 text-brand-subtext italic hidden sm:table-cell" data-id="element-181">
                      {item.desc}
                    </td>
                    <td className="p-4 text-brand-text font-semibold text-right whitespace-nowrap" data-id="element-182">
                      {item.price}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}